var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstall4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7855_47064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.026 38.3541L20.0152 28.5667M29.3248 25.8228C24.0659 29.1425 15.9656 29.1501 10.7005 25.8403C9.86734 25.3176 9.45131 25.0557 9.123 24.2817C8.79469 23.51 8.89622 23.0643 9.10041 22.1787C9.56128 20.1761 10.6502 18.5945 12.1552 17.3297C14.2703 15.5569 15.3278 14.6694 15.5596 13.9304C15.7915 13.1936 15.5283 12.2741 15.0054 10.434L14.34 8.10368C13.9034 6.56925 13.6839 5.80089 14.0977 4.92083C14.5115 4.04077 15.0416 3.79172 16.1018 3.29362C17.3177 2.71882 18.6458 2.42008 19.9907 2.41882C21.3357 2.41756 22.6643 2.71381 23.8813 3.28633C24.9424 3.78244 25.473 4.0305 25.8885 4.90978C26.3028 5.78792 26.0859 6.55554 25.6521 8.09308L24.9762 10.4784C24.4556 12.3162 24.1976 13.235 24.4343 13.977C24.6732 14.719 25.7163 15.5771 27.8026 17.2932C29.3363 18.554 30.45 20.1302 30.9204 22.1583C31.1251 23.0446 31.2274 23.4878 30.9006 24.2624C30.5737 25.0347 30.1582 25.2974 29.3248 25.8228Z",
    stroke: "#EDB755",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7855_47064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall4);
export default __webpack_public_path__ + "static/media/install_4.66f06d49a153f39063a81e77debdbc63.svg";
export { ForwardRef as ReactComponent };